export const FORM_BUILDER_DEV_MODE = false;
export const FORM_BUILDER_EDITOR_PATH = '/fein/editor';
export const FORM_BUILDER_TEMPLATES_PATH = '/fein/templates';
export const FORM_BUILDER_TEMPLATE_KEYS_PATH = '/fein/keys';
export const FORM_BUILDER_PREVIEW_PATH = '/fein/preview';
export const FORM_BUILDER_TEMPLATE_KEYS_PAGE_SIZE = 50;
export const FORM_BUILDER_TEMPLATES_PAGE_SIZE = 50;
export const FORM_BUILDER_TEMPLATE_KEYS_ON_SELECT_DEFAULT_PAGE_SIZE = 5;
export const FORM_BUILDER_TEMPLATES_ON_SELECT_DEFAULT_PAGE_SIZE = 10;
export const FORM_BUILDER_STORAGE_KEY = 'fein-state';
export const FORM_BUILDER_AUTO_SAVE_INTERVAL = 100; // 5 seconds
export const FORM_BUILDER_EDITOR_MODULES_PAGE_SIZE = 100;
export const FORM_BUILDER_DEBOUNCE_MS = 300;
export const FORM_BUILDER_DEV_STORAGE_KEY = 'form-builder-dev-mode';
export const FORM_BUILDER_PREVIEW_CONTEXT_STORAGE_KEY_PREFIX =
  'form-builder-preview-context';

export const getFormBuilderPreviewContextStorageKey = (templateId: string) =>
  `${FORM_BUILDER_PREVIEW_CONTEXT_STORAGE_KEY_PREFIX}:${templateId}`;

export const FORM_BUILDER_DEFAULT_EXPANDED_FOR_COMPONENT_PALETTE = true;

export const MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
] as const;
